export const GET_INTAKENOTES = "GET_INTAKENOTES";
export const GET_ADMIN_NOTES = "GET_ADMIN_NOTES";
